"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioButton = void 0;
var radioModule = require('./RadioButton.module.scss');
var react_1 = __importDefault(require("react"));
var Corpo_1 = require("../../Tipografia/Corpo/Corpo");
var Cores_1 = require("../../Cores/Cores");
var RadioButton = function (_a) {
    var id = _a.id, classes = _a.classes, _b = _a.titulo, titulo = _b === void 0 ? "Radio" : _b, valor = _a.valor, valorRadioGrupo = _a.valorRadioGrupo, _c = _a.desabilitado, desabilitado = _c === void 0 ? false : _c, _d = _a.radioGrupo, radioGrupo = _d === void 0 ? "gruporadio1" : _d, onChange = _a.onChange, children = _a.children, style = _a.style;
    var handleChange = function (event) {
        if (!desabilitado) {
            onChange && onChange(event.target.value);
        }
    };
    return (react_1.default.createElement("div", { style: style, className: "".concat(radioModule.radioButton, " ").concat(classes, " ").concat(desabilitado ? radioModule.desabilitado : '') },
        react_1.default.createElement("input", { type: "radio", id: id, value: valor, name: radioGrupo, onChange: handleChange, disabled: desabilitado, checked: valor === valorRadioGrupo }),
        react_1.default.createElement("label", { htmlFor: id }, children ? children :
            react_1.default.createElement(Corpo_1.Corpo, { tipo: "label1", cor: Cores_1.Cores.TextoPadrao.CinzaMU600 }, titulo))));
};
exports.RadioButton = RadioButton;
